import { tableConstantsFactory } from './tableConstantsFactory';
const userConstants = tableConstantsFactory('USER');
export default userConstants;